"use client"

import SquareCta, { type SquareCtaProps } from "~/components/ui/SquareCta"
import { useFiltersRealTimeSelection } from "~/providers/AlgoliaCustomContext/FiltersRealTimeSelection/index.client"
import { ClientTranslate } from "~/providers/I18nProvider/ClientTranslate"
import { objectValues } from "~/utils/object-values"

export function FiltersSubmitButton(props: SquareCtaProps) {
  const { currentSelection } = useFiltersRealTimeSelection()

  const currentlySelectedFiltersAmount = objectValues(currentSelection)
    ?.filter(Boolean)
    ?.reduce((acc, facet) => {
      return acc + (objectValues(facet)?.filter(Boolean)?.length || 0)
    }, 0)

  return (
    <SquareCta {...props} htmlType="submit" fill theme="backgroundBlack">
      <ClientTranslate tKey="cta_apply_filters" options={{ amount: currentlySelectedFiltersAmount }} />
    </SquareCta>
  )
}
